import React, { useContext } from 'react';
import { IComponentGuests } from '../../component';
import ActFlow from '../ButtonGroup/ActFlow';
import './AllForActFlow.scss';
import { getNameByType } from '../ButtonGroup/AllForButtonGroup';
import { ThemeContext } from '../../store/ThemeProvider';
import { getCompatibleCls } from '../../utils/dom';

const AllForActFlow = function(props: IComponentGuests) {
  const { h1Color } = useContext(ThemeContext);

  const { edittype, content, api } = props;

  const cls = getCompatibleCls('all-for-actflow', api);

  return (
    <div className={cls}>
      <div className="title" style={{ color: h1Color }}>
        {getNameByType('act-flow')}
      </div>
      {edittype == 'rich' && typeof content == 'string' ? (
        <div
          className="html-rawdata"
          dangerouslySetInnerHTML={{ __html: content || '' }}
        ></div>
      ) : (
        <ActFlow {...props} />
      )}
    </div>
  );
};

export default AllForActFlow;
